import { Injectable } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {SpesenService} from '../../spesen.service';
import {catchError, map, mergeMap} from 'rxjs/operators';
import {of} from 'rxjs';
import {loadSpesenFailed, loadSpesenStart, loadSpesenSucceeded} from '../actions/getAllSpesen.actions';
import {deleteSpeseFailed, deleteSpeseStart, deleteSpeseSucceeded} from '../actions/spese-del.actions';
import {loadSpesenartenFailed, loadSpesenartenStart, loadSpesenartenSucceeded} from '../actions/spesenart.actions';
import {addSpesenFailed, addSpesenStart, addSpesenSucceeded} from '../actions/spesen-add.actions';
import {editSpesenFailed, editSpesenStart, editSpesenSucceeded} from '../actions/spesen-edit.actions';
import {deleteAllSpesenOfZeitStart, deleteAllSpesenOfZeitSucceeded} from '../actions/allSpesenOfZeit-del.actions';
import {getFilteredSeekDateStart} from '../actions/filter-seek-date.actions';

@Injectable()
export class SpesenEffects {


  public loadSpesen$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadSpesenStart),
      mergeMap((zeitId) =>
        this.spesenService.getAllSpesen(zeitId.zeitId).pipe(
          map((response) => loadSpesenSucceeded({ item: response.data })),
          catchError((e) => of(loadSpesenFailed(e))),
        ),
      ),
    ),
  );



  public deleteSpese$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteSpeseStart),
      mergeMap((spese) =>
        this.spesenService.deleteSpese(spese.item).pipe(
          mergeMap((response) => of(deleteSpeseSucceeded({ item: response }), loadSpesenStart({zeitId: spese.item.zeitId}))),
          catchError((e) => of(deleteSpeseFailed(e))),
        ),
      ),
    ),
  );

  public deleteAllSpesenOfZeit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteAllSpesenOfZeitStart),
      mergeMap((zeitId) =>
        this.spesenService.deleteAllSpesenOfZeit(zeitId.zeitId).pipe(
          mergeMap((response) => of(deleteAllSpesenOfZeitSucceeded({ item: response }), loadSpesenStart({zeitId: zeitId.zeitId}))),
          catchError((e) => of(deleteSpeseFailed(e))),
        ),
      ),
    ),
  );

  public addSpese$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addSpesenStart),
      mergeMap((spese) =>
        this.spesenService.addSpesen(spese.item).pipe(
          // tslint:disable-next-line:max-line-length
          mergeMap((response) => of( addSpesenSucceeded({ item: response }), loadSpesenStart({zeitId: spese.item.zeitId}) )),
          catchError((e) => of(addSpesenFailed(e))),
        ),
      ),
    ),
  );

  public editSpese$ = createEffect(() =>
    this.actions$.pipe(
      ofType(editSpesenStart),
      mergeMap((spese) =>
        this.spesenService.editSpesen(spese.item).pipe(
          mergeMap((response) => of( editSpesenSucceeded({ item: response }), loadSpesenStart({zeitId: spese.item.zeitId}) )),
          catchError((e) => of(editSpesenFailed(e))),
        ),
      ),
    ),
  );


  /**
   * Constructor of Zeit effects
   *
   * @param actions$ - The action observable
   * @param dS = DummyService - The Zeit service
   */
  constructor(private actions$: Actions, private spesenService: SpesenService) {}
}
